export default `
    mutation identifyme($input:MySelf){
        identifyMe(input:$input)
    }
`;
